export default __webpack_public_path__ + "static/media/case-insensitive.290bfc0f.svg";